import { getSessionContextSources } from '@/helpers/sessionContextSources';
import { useQuerySessionContextFiles } from '@/hooks/query/useQuerySessionContextFiles';
import { useQuerySessionPatientDocumentLinks } from '@/hooks/query/useQuerySessionPatientDocumentLinks';
import { useQuerySessionById } from '@heidi/session/data';

/** Returns session-keyed context source data and generation-readiness facts. */
export function useSessionContextSources(sessionId: string) {
  const { data: session } = useQuerySessionById({
    sessionId,
    select: (data) => {
      if (!data) return undefined;
      return { clinician_notes: data.clinician_notes };
    },
  });
  const { data: contextFiles } = useQuerySessionContextFiles(sessionId);
  const { data: linkedPatientDocuments } = useQuerySessionPatientDocumentLinks(sessionId);
  const clinicianNotes = session?.clinician_notes;

  return {
    clinicianNotes,
    contextFiles,
    linkedPatientDocuments,
    ...getSessionContextSources({
      clinicianNotes,
      contextFiles,
      linkedPatientDocuments,
    }),
  };
}
